import {
    tokens,
    createDarkTheme,
    createLightTheme,
    BrandVariants,
    Theme,
} from '@fluentui/react-components';

const myNewTheme: BrandVariants = {
    10: "#020305",
    20: "#111723",
    30: "#16263D",
    40: "#193253",
    50: "#1B3F6A",
    60: "#1B4C82",
    70: "#18599B",
    80: "#1267B4",
    90: "#3174C2",
    100: "#4F82C8",
    110: "#6790CF",
    120: "#7D9ED5",
    130: "#92ACDC",
    140: "#A6BAE2",
    150: "#BAC9E9",
    160: "#CDD8EF"
};

export const lightTheme: Theme = {
    ...createLightTheme(myNewTheme),
};

export const darkTheme: Theme = {
    ...createDarkTheme(myNewTheme),
};


darkTheme.colorBrandForeground1 = myNewTheme[110];
darkTheme.colorBrandForeground2 = myNewTheme[120];

// Create shared styles
export const sharedStyles = {
    elevation1: {
        boxShadow: tokens.shadow2,
        backgroundColor: tokens.colorNeutralBackground1,
    },
    elevation2: {
        boxShadow: tokens.shadow4,
        backgroundColor: tokens.colorNeutralBackground2,
    },
    elevation3: {
        boxShadow: tokens.shadow8,
        backgroundColor: tokens.colorNeutralBackground3,
    },
    elevation4: {
        boxShadow: tokens.shadow16,
        backgroundColor: tokens.colorNeutralBackground4,
    },
    interactive: {
        transition: 'all 0.2s ease-in-out',
        ':hover': {
            transform: 'translateY(-2px)',
        },
        ':active': {
            transform: 'translateY(0)',
        },
    },
};